

import action from './action';
import Icon from 'vux/src/components/icon/index.vue'

import { yoButton } from 'components';

export default {
name: 'index',
props: ['params'],
metaInfo() {
return {
title: this.pageTitle
};
},
created: async function () {

},
data() {
return {
pageTitle: '正在进入...',
};
},
mounted () {
this.bfscrolltop = document.body.scrollTop
},
computed: {},
filters: {},
components: {
Icon,
yoButton
},
methods: {
...action,
},
beforeRouteEnter(to, from, next) {
next();
},
beforeRouteUpdate(to, from, next) {
next();
}
};



// WEBPACK FOOTER //
// ./src/module/wechat/jump.vue